export default __webpack_public_path__ + "static/media/flowls_white_alt2.14276c8c.png";